import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <defs>
      <radialGradient
        id="radial-gradient"
        cx="50"
        cy="48"
        r="20.74"
        fx="50"
        fy="48"
        gradientTransform="translate(0 2)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fffbd1"></stop>
        <stop offset="0.2" stopColor="#ffe895"></stop>
        <stop offset="0.5" stopColor="#fac080"></stop>
      </radialGradient>
      <linearGradient
        id="linear-gradient"
        x1="43.66"
        x2="56.66"
        y1="41.55"
        y2="54.96"
        gradientTransform="translate(0 2)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.5" stopColor="#fbe2b6"></stop>
        <stop offset="1" stopColor="#f9c670"></stop>
      </linearGradient>
      <radialGradient
        id="radial-gradient-light"
        cx="49.94"
        cy="50.02"
        r="15.66"
        fx="49.94"
        fy="50.02"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.25" stopColor="#feeed0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </radialGradient>
    </defs>
    <path
      id="c-path"
      d="M50 50s13.62 2.71 13.7-7.54c.04-10.29-13.7-8.41-13.7-8.41S38.05 35.26 38.84 50C39.63 64.79 50 65.58 50 65.58s12.91 2.12 13.37-7.16C63.83 49.17 50 50.01 50 50.01Z"
      fill="none"
      stroke="none"
    />
    <g>
      <g id="C1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 100 100">
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="37.69"
              x2="70.1"
              y1="994.3"
              y2="951.4"
              gradientTransform="matrix(1 0 0 -1 0 1024)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#98c7ff"></stop>
              <stop offset="0" stopColor="#c4b4fe"></stop>
              <stop offset="0.3" stopColor="#ffd6ef"></stop>
              <stop offset="0.5" stopColor="#dfebff"></stop>
              <stop offset="0.6" stopColor="#ffedea"></stop>
              <stop offset="0.9" stopColor="#98c7ff"></stop>
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="35.75"
              x2="68.15"
              y1="992.86"
              y2="949.92"
              gradientTransform="matrix(1 0 0 -1 0 1024)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#98c7ff"></stop>
              <stop offset="0" stopColor="#d4b5ff"></stop>
              <stop offset="0.3" stopColor="#ffe3f4"></stop>
              <stop offset="0.4" stopColor="#f4edf9"></stop>
              <stop offset="0.6" stopColor="#c2d8ff"></stop>
              <stop offset="0.8" stopColor="#ffc2c4"></stop>
            </linearGradient>
            <clipPath id="clippath">
              <path
                fill="none"
                d="M63.41 34.92s1 8.66.75 9.83c0 0 0 .25-.62.25 0 0-.12.08-.54-1.37-.42-1.46-2.96-9.33-10.45-9 0 0-3.17-.29-6 2.46s-4.04 9.33-3.87 12.83c.17 3.46.21 15.49 10.45 15.2 10.29-.29 10.04-6.5 10.04-6.5s0-.21.21-.21.25.21.25.21.12 7.79-10.95 7.71c-11.08-.08-16.95-6.54-16.87-16.16s6.66-16.49 16.29-16.49c0 0 3.54-.33 8.95 1.83 0 0 .5.25.54.04 0 0 1-1.54 1.12-1.46 0 0 .62-.17.75.79l-.04.04Z"></path>
            </clipPath>
          </defs>
          <path
            fill="url(#linear-gradient)"
            d="M63.41 34.92s1 8.66.75 9.83c0 0 0 .25-.62.25 0 0-.12.08-.54-1.37s-2.96-9.33-10.45-9c0 0-3.17-.29-6 2.46s-4.04 9.33-3.87 12.83c.17 3.46.21 15.49 10.45 15.2 10.29-.29 10.04-6.5 10.04-6.5s0-.21.21-.21.25.21.25.21.12 7.79-10.95 7.71c-11.08-.08-16.95-6.54-16.87-16.16s6.66-16.49 16.29-16.49c0 0 3.54-.33 8.95 1.83 0 0 .5.25.54.04 0 0 1-1.54 1.12-1.46 0 0 .62-.17.75.79l-.04.04Z"></path>
          <g clipPath="url(#clippath)">
            <path fill="url(#linear-gradient-2)" d="M35.55 33.46h28.91v33.11H35.55z"></path>
          </g>
        </svg>
      </g>
      <g id="C2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 100 100">
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="37.69"
              x2="70.1"
              y1="994.3"
              y2="951.4"
              gradientTransform="matrix(1 0 0 -1 0 1024)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#98c7ff"></stop>
              <stop offset="0" stopColor="#c4b4fe"></stop>
              <stop offset="0.3" stopColor="#ffd6ef"></stop>
              <stop offset="0.5" stopColor="#dfebff"></stop>
              <stop offset="0.6" stopColor="#ffedea"></stop>
              <stop offset="0.9" stopColor="#98c7ff"></stop>
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="35.75"
              x2="68.15"
              y1="992.86"
              y2="949.92"
              gradientTransform="matrix(1 0 0 -1 0 1024)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#98c7ff"></stop>
              <stop offset="0" stopColor="#d4b5ff"></stop>
              <stop offset="0.3" stopColor="#ffe3f4"></stop>
              <stop offset="0.4" stopColor="#f4edf9"></stop>
              <stop offset="0.6" stopColor="#c2d8ff"></stop>
              <stop offset="0.8" stopColor="#ffc2c4"></stop>
            </linearGradient>
            <clipPath id="clippath">
              <path
                fill="none"
                d="M63.41 34.92s1 8.66.75 9.83c0 0 0 .25-.62.25 0 0-.12.08-.54-1.37-.42-1.46-2.96-9.33-10.45-9 0 0-3.17-.29-6 2.46s-4.04 9.33-3.87 12.83c.17 3.46.21 15.49 10.45 15.2 10.29-.29 10.04-6.5 10.04-6.5s0-.21.21-.21.25.21.25.21.12 7.79-10.95 7.71c-11.08-.08-16.95-6.54-16.87-16.16s6.66-16.49 16.29-16.49c0 0 3.54-.33 8.95 1.83 0 0 .5.25.54.04 0 0 1-1.54 1.12-1.46 0 0 .62-.17.75.79l-.04.04Z"></path>
            </clipPath>
          </defs>
          <path
            fill="url(#linear-gradient)"
            d="M63.41 34.92s1 8.66.75 9.83c0 0 0 .25-.62.25 0 0-.12.08-.54-1.37s-2.96-9.33-10.45-9c0 0-3.17-.29-6 2.46s-4.04 9.33-3.87 12.83c.17 3.46.21 15.49 10.45 15.2 10.29-.29 10.04-6.5 10.04-6.5s0-.21.21-.21.25.21.25.21.12 7.79-10.95 7.71c-11.08-.08-16.95-6.54-16.87-16.16s6.66-16.49 16.29-16.49c0 0 3.54-.33 8.95 1.83 0 0 .5.25.54.04 0 0 1-1.54 1.12-1.46 0 0 .62-.17.75.79l-.04.04Z"></path>
          <g clipPath="url(#clippath)">
            <path fill="url(#linear-gradient-2)" d="M35.55 33.46h28.91v33.11H35.55z"></path>
          </g>
        </svg>
      </g>
      <g id="light">
        <g transform="translate(-50,-50)">
          <circle cx="49.94" cy="50.02" r="15.66" fill="url(#radial-gradient-light)"></circle>
        </g>
      </g>
      <g id="p1">
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 100 100">
          <defs>
            <radialGradient
              id="radial-gradient-p1"
              cx="69.8"
              cy="33.2"
              r="5.7"
              fx="69.8"
              fy="33.2"
              gradientTransform="matrix(1 0 0 -1 0 100)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#ffe7b8"></stop>
              <stop offset="0.5" stopColor="#fad7aa"></stop>
            </radialGradient>
          </defs>
          <path
            fill="url(#radial-gradient-p1)"
            d="m69.8 61.1.3 4.5s.1.2.2 0l2.4-2.1-1.9 2.5v.2l4.5.3-4.5.3s-.2.1 0 .2l2.1 2.7-2.6-2.2h-.2l-.3 7.3-.3-7.3s-.1-.2-.2 0l-2.8 2.4 2.4-2.9v-.2l-4.5-.3 4.5-.3s.2-.1 0-.2L67 63.5l2.4 2h.2l.3-4.5Z"></path>
        </svg>
      </g>
      <g id="p2">
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 100 100">
          <defs>
            <linearGradient
              id="linear-gradient-p2"
              x1="31.5"
              x2="48.2"
              y1="41.6"
              y2="41.6"
              gradientTransform="matrix(.8 0 0 -1 4.1 97.3)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.3" stopColor="#ffde99"></stop>
              <stop offset="0.4" stopColor="#ffe9bc" stopOpacity="0.6"></stop>
              <stop offset="0.4" stopColor="#fff5e0" stopOpacity="0.3"></stop>
              <stop offset="0.5" stopColor="#fffcf6" stopOpacity="0"></stop>
              <stop offset="0.5" stopColor="#fff" stopOpacity="0"></stop>
              <stop offset="0.5" stopColor="#fffbf3" stopOpacity="0.1"></stop>
              <stop offset="0.6" stopColor="#fff1d6" stopOpacity="0.4"></stop>
              <stop offset="0.7" stopColor="#ffe2a8" stopOpacity="0.9"></stop>
              <stop offset="0.7" stopColor="#fd9"></stop>
            </linearGradient>
            <linearGradient
              id="linear-gradient1-p2"
              x1="70.4"
              x2="87.1"
              y1="42.3"
              y2="42.3"
              gradientTransform="matrix(.8 0 0 -1 2 86.8)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.3" stopColor="#ffde99"></stop>
              <stop offset="0.4" stopColor="#ffe9bc" stopOpacity="0.6"></stop>
              <stop offset="0.4" stopColor="#fff5e0" stopOpacity="0.3"></stop>
              <stop offset="0.5" stopColor="#fffcf6" stopOpacity="0"></stop>
              <stop offset="0.5" stopColor="#fff" stopOpacity="0"></stop>
              <stop offset="0.5" stopColor="#fffbf3" stopOpacity="0.1"></stop>
              <stop offset="0.6" stopColor="#fff1d6" stopOpacity="0.4"></stop>
              <stop offset="0.7" stopColor="#ffe2a8" stopOpacity="0.9"></stop>
              <stop offset="0.7" stopColor="#fd9"></stop>
            </linearGradient>
            <radialGradient
              id="radial-gradient-p2"
              cx="33.5"
              cy="66.5"
              r="3.8"
              fx="33.5"
              fy="66.5"
              gradientTransform="matrix(1 0 0 -1 0 100)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#fff0f0"></stop>
              <stop offset="0.5" stopColor="#fadada"></stop>
            </radialGradient>
          </defs>
          <path
            fill="url(#radial-gradient-p2)"
            d="m33.5 29.7.2 3h.1l1.6-1.4-1.3 1.7v.1l3 .2-3 .2v.1l1.4 1.8-1.7-1.5h-.1l-.2 4.8-.2-4.8h-.1l-1.9 1.6 1.6-1.9v-.1l-3-.2 3-.2V33l-1.3-1.7 1.6 1.4h.1z"></path>
          <rect
            width="13.5"
            height="0.3"
            x="28.8"
            y="55.5"
            fill="url(#linear-gradient-p2)"
            rx="0.1"
            ry="0.1"
            transform="rotate(-21.6 35.559 55.68)"></rect>
          <rect
            width="13.4"
            height="0.3"
            x="57.2"
            y="44.3"
            fill="url(#linear-gradient1-p2)"
            rx="0.1"
            ry="0.1"
            transform="rotate(-21.3 64.029 44.525)"></rect>
          <circle cx="28.6" cy="58.4" r="0.3" fill="#ffdf94"></circle>
          <circle cx="65.8" cy="68.6" r="0.3" fill="#ffe9b5"></circle>
        </svg>
      </g>
      <g id="p3">
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 100 100">
          <defs>
            <radialGradient
              id="radial-gradient-p3"
              cx="62.8"
              cy="40.3"
              r="3.5"
              fx="62.8"
              fy="40.3"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#f1e3ff"></stop>
              <stop offset="0.8" stopColor="#d2aafa"></stop>
            </radialGradient>
          </defs>
          <path
            fill="url(#radial-gradient-p3)"
            d="m62.8 36.8.2 2.8c0 .3.3.5.6.6l2.8.2-2.8.2c-.3 0-.5.3-.6.6l-.2 2.8-.2-2.8c0-.3-.3-.5-.6-.6l-2.8-.2 2.8-.2c.3 0 .5-.3.6-.6z"></path>
          <circle cx="38.6" cy="41.9" r="0.3" fill="#ffccdc"></circle>
          <circle cx="36.9" cy="32.4" r="0.3" fill="#ffe0f4"></circle>
        </svg>
      </g>
      <g id="p4">
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 100 100">
          <defs>
            <radialGradient
              id="radial-gradient-p4"
              cx="66"
              cy="62.4"
              r="2.2"
              fx="66"
              fy="62.4"
              gradientTransform="matrix(1 0 0 -1 0 100)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#f1e3ff"></stop>
              <stop offset="0.8" stopColor="#d2aafa"></stop>
            </radialGradient>
            <radialGradient
              id="radial-gradient1-p4"
              cx="39.8"
              cy="38.9"
              r="2"
              fx="39.8"
              fy="38.9"
              gradientTransform="matrix(1 0 0 -1 0 100)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#e3f9ff"></stop>
              <stop offset="0.8" stopColor="#aae9fa"></stop>
            </radialGradient>
          </defs>
          <path
            fill="url(#radial-gradient-p4)"
            d="M66 35.4V37c.1.3.4.5.7.6h1.6l-1.6.2c-.3 0-.6.3-.6.6V40l-.2-1.6c0-.3-.3-.5-.6-.6h-1.6l1.6-.2c.3 0 .6-.3.6-.6v-1.6Z"></path>
          <path
            fill="url(#radial-gradient1-p4)"
            d="M39.8 59v1.4c.1.3.3.5.7.6h1.4l-1.4.2c-.3 0-.5.3-.6.6v1.4l-.2-1.4c0-.3-.3-.5-.6-.6h-1.4l1.4-.2c.3 0 .5-.3.6-.6V59Z"></path>
          <circle cx="61.6" cy="36.8" r="0.3" fill="#dcd9ff"></circle>
        </svg>
      </g>
      <g id="star">
        <g transform="translate(-50,-50)">
          <path
            fill="url(#linear-gradient)"
            d="M52.5 46.92s-2.37 2.12-4.87.08l-6.21-5.58L47 47.63c2.04 2.5-.08 4.87-.08 4.87l-5.46 6-.08.08 6-5.46s2.37-2.12 4.87-.08l6.21 5.58-5.58-6.21c-2.04-2.5.08-4.87.08-4.87l5.46-6 .08-.08z"></path>
          <path
            fill="url(#radial-gradient)"
            d="M56.79 49.29s-5.41-.29-6-5.83l-.71-14.29-.71 14.29c-.58 5.54-6 5.83-6 5.83L29.46 50h-.17l13.91.71s5.41.29 6 5.83l.71 14.29.71-14.29c.58-5.54 6-5.83 6-5.83L70.53 50h.17z"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default IconLoader;
